/**
 * TasksCell - the Tasks column in the Opportunities and Projects tables.
 *
 * Shows EVERY task on the row, open and done, stacked. It used to show only
 * the latest and hide the rest behind a hover popover, which meant reading a
 * busy project one mouse-over at a time and never being able to compare two
 * rows at once. The row gets taller; that is the trade, and it was asked for.
 *
 * Tasks are handed in from the table's ONE indexed fetch (useProjectTasksIndex),
 * never fetched per row - that would be hundreds of requests on a full table.
 */
import { fmtDate } from '../../utils/format';
import { isOverdue, sortTasks } from './useTasks';
import { taggedOf, taggedTitle } from './tagged';

const GREEN = '#1B5E20';
const AMBER = '#B07503';

export default function TasksCell({ tasks: rows }) {
  const tasks = sortTasks(rows || []);
  if (!tasks.length) return <span style={{ color: '#C9C9C9', fontSize: 10.5 }}>-</span>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, minWidth: 0 }}>
      {tasks.map((t) => {
        const done = t.status !== 'open';
        const late = isOverdue(t);
        const tagged = taggedOf(t);
        return (
          <div key={t.id} style={{ display: 'flex', gap: 5, alignItems: 'flex-start', minWidth: 0 }}>
            <span
              style={{
                flexShrink: 0,
                marginTop: 2,
                width: 9,
                height: 9,
                borderRadius: 2.5,
                border: `1.5px solid ${done ? GREEN : '#BBB'}`,
                background: done ? GREEN : '#fff',
                color: '#fff',
                fontSize: 7,
                lineHeight: '7px',
                textAlign: 'center',
                fontWeight: 900,
              }}
            >
              {done ? '✓' : ''}
            </span>
            <span style={{ minWidth: 0 }}>
              <span
                style={{
                  display: 'block',
                  fontSize: 10,
                  lineHeight: 1.35,
                  wordBreak: 'break-word',
                  color: done ? '#9A9A9A' : '#333',
                  textDecoration: done ? 'line-through' : 'none',
                }}
              >
                {t.description}
              </span>
              <span
                style={{ display: 'block', fontSize: 8.5, marginTop: 1, color: late ? AMBER : '#9A9A9A', fontWeight: late ? 700 : 400 }}
              >
                {t.owner}
                {tagged.length > 0 && <span title={taggedTitle(tagged)}> +{tagged.length}</span>}
                {' · '}
                {fmtDate(t.due_date)}
                {late ? ' · overdue' : ''}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
